module.exports = __webpack_public_path__ + "static/media/knc.55fd2000.svg";